'use strict';

var ConfigurationParameterModalGridAddRowButtonDirective = function ConfigurationParameterModalGridAddRowButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    template: require('../templates/grid-add-row-button.html'),
    controller: 'ConfigurationParameterModalGridAddRowButtonController',
    scope: true
  };
};
ConfigurationParameterModalGridAddRowButtonDirective.$inject = [];
module.exports = ConfigurationParameterModalGridAddRowButtonDirective;